module.exports = __webpack_public_path__ + "img/refresh.1df2066a.svg";